import { useAuth } from '../context/AuthContext';
import { useSubscription } from '../context/SubscriptionContext';

const useCanPlayFree = () => {
  const { user } = useAuth();
  const { isSubscribed } = useSubscription();
  return !!(isSubscribed || user?.is_admin);
};

export default useCanPlayFree;
